module.exports = "/_next/static/files/38e9effc5559df540b034ccedd1e62e5.png";